<template>
  <div>
    <VSnackbar
      v-for="(snackbarElement, index) in snackbarElements"
      :key="index"
      :model-value="snackbarElement.display"
      :timeout="snackbarElement.timeout"
      :color="snackbarElement.color"
      location="top center"
      multi-line
    >
      <span class="text-white">{{ snackbarElement.text }}</span>
      <template #actions>
        <SocioBtn variant="text" text="Close" @click="closeSnackbar(index)" />
      </template>
    </VSnackbar>
  </div>
</template>

<script setup>
import { computed, ref, watch } from "vue";
import { useNotificationsStore } from "@/store/notification";

const DEFAULT_TIMEOUT = 6000;

const notificationsStore = useNotificationsStore();

const snackbarElements = ref([]);

const lastNotification = computed(() => notificationsStore.getLastNotification);

watch(lastNotification, (notification) => {
  if (!notification) return;
  const snackbarElement = { ...notification, display: true, timeout: -1 };
  notificationsStore.setLastNotification(null);
  snackbarElements.value.push(snackbarElement);
  setTimeout(() => {
    const index = snackbarElements.value.indexOf(snackbarElement);
    if (index !== -1) snackbarElements.value.splice(index, 1);
  }, notification.timeout || DEFAULT_TIMEOUT);
});

function closeSnackbar(index) {
  snackbarElements.value.splice(index, 1);
}
</script>
